/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSquareRoundedLetterE = createReactComponent("outline", "square-rounded-letter-e", "IconSquareRoundedLetterE", [["path", { "d": "M14 8h-4v8h4", "key": "svg-0" }], ["path", { "d": "M10 12h2.5", "key": "svg-1" }], ["path", { "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z", "key": "svg-2" }]]);

export { IconSquareRoundedLetterE as default };
//# sourceMappingURL=IconSquareRoundedLetterE.mjs.map
